import {
  Box,
  Paper,
  Stack,
  Table,
  TableBody,
  TableContainer,
  useTheme,
} from '@mui/material';
import { generateClient } from 'aws-amplify/api';
import { useEffect, useState } from 'react';
import ReactLoading from 'react-loading';
import { Schema } from '../../../../../amplify/data/resource';
import Item from './Item';

const apiClient = generateClient<Schema>();

const Funds: React.FC = () => {
  const theme = useTheme();

  const [funds, setFunds] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchFunds = async () => {
      try {
        setLoading(true);
        const response = await apiClient.queries.getAgentFunds({});
        if (response && response.data) {
          if (typeof response.data === 'string') {
            const parsedResponse = JSON.parse(response.data);
            setTimeout(() => {
              setFunds(parsedResponse.body);
              setLoading(false);
            }, 1000);
          } else {
            console.error(
              'Error: response.data is not a string.',
              response.data,
            );
          }
        } else {
          console.error('Error: No funds data.');
        }
      } catch (error) {
        console.error('Error fetching funds data:', error);
      }
    };

    fetchFunds();
  }, []);

  return (
    <Box sx={{ direction: 'rtl' }}>
      {loading ? (
        <Stack justifyContent="center" alignItems="center" width="100%">
          <ReactLoading
            type={'bubbles'}
            color={theme.palette.green.main}
            height={250}
            width={250}
          />
        </Stack>
      ) : (
        <TableContainer
          component={Paper}
          sx={{
            backgroundColor: 'transparent',
            boxShadow: 'none',
            maxHeight: '600px',
            overflowY: 'auto',
          }}
        >
          <Table
            stickyHeader
            sx={{
              backgroundColor: 'transparent',
              borderCollapse: 'separate',
              borderSpacing: '0 10px',
            }}
          >
            <TableBody>
              {funds &&
                Object.entries(funds).map(([fundName, products]) => (
                  <Item
                    key={fundName}
                    fundName={fundName}
                    products={products}
                  />
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default Funds;
